// extracted by mini-css-extract-plugin
export default {"root":"SelectFromCloudBreadcrumbs__root--2bjvF","counter":"SelectFromCloudBreadcrumbs__counter--2md60"};